module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetMedium@2x.9fc6b83.webp";